const FacebookIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 8C16 3.58127 12.4187 0 8 0C3.58127 0 0 3.58127 0 8C0 11.9938 2.925 15.3031 6.75 15.9031V10.3125H4.71873V8H6.75V6.2375C6.75 4.2328 7.94377 3.125 9.77187 3.125C10.6469 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5531C9.55937 5.25 9.25 5.8672 9.25 6.5V8H11.4687L11.1141 10.3125H9.25V15.9031C13.075 15.3031 16 11.9938 16 8Z"
                fill="#4B10FF"
            />
            <path
                d="M11.1141 10.3125L11.4687 8H9.24999V6.5C9.24999 5.8672 9.55935 5.25 10.5531 5.25H11.5625V3.28125C11.5625 3.28125 10.6469 3.125 9.77185 3.125C7.94375 3.125 6.74999 4.2328 6.74999 6.2375V8H4.71872V10.3125H6.74999V15.9031C7.15779 15.9672 7.57499 16 7.99999 16C8.42499 16 8.84219 15.9672 9.24999 15.9031V10.3125H11.1141Z"
                fill="#181A20"
            />
        </svg>
    );
};

export default FacebookIcon;
